import { render, staticRenderFns } from "./pay-as-you-go.vue?vue&type=template&id=76eddb1c&"
import script from "./pay-as-you-go.vue?vue&type=script&lang=js&"
export * from "./pay-as-you-go.vue?vue&type=script&lang=js&"
import style0 from "./pay-as-you-go.vue?vue&type=style&index=0&id=76eddb1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports